module.exports = __webpack_public_path__ + "img/Multiple_sequence_alignment_1.93669a6b.jpg";